import Button from '@/components/base/Button';

export interface DashboardAlertItem {
  id: string;
  orderNo: string;
  title: string;
  note: string;
  waitingFor: string;
}

interface DashboardAlertsProps {
  alerts: DashboardAlertItem[];
  onAssign: (orderNo: string) => void;
  onOpenOrder: (orderNo: string) => void;
}

export default function DashboardAlerts({ alerts, onAssign, onOpenOrder }: DashboardAlertsProps) {
  if (alerts.length === 0) return null;

  return (
    <section>
      <div className="mb-3 flex items-center gap-2">
        <h2 className="font-semibold text-base text-foreground-950">تنبيهات تحتاج تدخل</h2>
        <span className="flex h-5 min-w-5 items-center justify-center rounded-full bg-warning-500 px-1.5 text-[11px] font-semibold text-white">
          {alerts.length}
        </span>
      </div>

      <div className="space-y-3">
        {alerts.map((alert) => (
          <div
            key={alert.id}
            className="flex flex-col gap-3 rounded-[10px] border border-warning-100 border-e-[3px] border-e-warning-500 bg-accent-50 px-4 py-3.5 sm:flex-row sm:items-center sm:justify-between"
          >
            <div className="flex items-start gap-3">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-warning-100 text-warning-700">
                <i className="ri-alarm-warning-line text-lg" aria-hidden="true"></i>
              </span>
              <div className="min-w-0">
                <button
                  type="button"
                  onClick={() => onOpenOrder(alert.orderNo)}
                  className="text-start font-medium text-[14px] text-foreground-950 transition-colors hover:text-secondary-600"
                >
                  {alert.title}
                </button>
                <p className="mt-0.5 text-[13px] leading-relaxed text-foreground-600">
                  {alert.note}
                </p>
                <p className="mt-1 flex items-center gap-1.5 text-[12px] text-warning-700">
                  <i className="ri-time-line text-sm" aria-hidden="true"></i>
                  بانتظار مندوب {alert.waitingFor}
                </p>
              </div>
            </div>

            <div className="flex shrink-0 items-center gap-2 ps-12 sm:ps-0">
              <Button
                size="sm"
                variant="cta"
                icon="ri-user-add-line"
                onClick={() => onAssign(alert.orderNo)}
              >
                عيّن مندوب
              </Button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}